module.exports = __webpack_public_path__ + "img/banner-advert-page-horizontal.891dcd21.svg";